import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AvFooterComponent } from '../../Shared/Components/av-footer/av-footer.component';
import { AvHeaderComponent } from '../../Shared/Components/av-header/av-header.component';
import { AvSidenavComponent } from '../../Shared/Components/av-sidenav/av-sidenav.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, AvFooterComponent, AvHeaderComponent, AvSidenavComponent],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-flex flex-column gap-2 overflow-hidden' },
})
export class ShellComponent {}
